module.exports = __webpack_public_path__ + "images/emoji/grapes.44bb245f74cdd06d119e.png";